import { css } from "@emotion/react";

export const sideMenuCSS = () => {
    return css`
    
        .SidebarContainer{
            width: 100%;
            overflow-x: hidden;
            height: 100vh;

            display: flex;
            justify-content: flex-end;

            z-index: 3;

            position: absolute;
            top: 0;
            left: 0;

       

            background-color: rgba(0,0,0,0.4);
            
            
            .Sidebar{
                
                width: 80%;
                max-width: 500px;
                height: 100%;

                overflow: hidden;

                display: flex;
                flex-direction: column;

                background-color: white;

                padding: 0rem 1rem;
                
                .TopSection{
                    padding-top: 1rem;
                    display: flex;
                    justify-content: flex-end;

                    .ExitIcon{
                        font-size: calc(1rem + 4vw);
                        color: #32B8DF;
                    }
                }


                // CLASES PARA LOS ELEMENTOS HIJOS //
                .IndividualItem{
                    margin-left: 0.6rem;
                    margin-right: 0.4rem;

                    width: 100%;
                    height: 8vh;
                    display: flex;
                    align-items:center;
                    gap: 1rem;

                    .SVG-Container{
                        display: flex;
                    }

                    .itemLabel{
                        text-decoration: unset;
                    }
                }


                .LangAndProf{
                    display: flex !important;
                    flex-direction: column;
                    align-items: center;
                    gap: 0.8rem;

                    .Languaje{
                        width: 100%;
                        display: flex;
                        justify-content: center;
                        gap: 0.5rem;
            
                        .LanguajeContainer{
                            display: flex;
                            padding:0.5rem;
                            border: 2px solid #fff;
                            height: 3rem;
                            width: 35%;
                            justify-content: center;
                            cursor: pointer;
                            line-height: 1.5;
                            align-items:center;

                            font-size: calc(1rem + 0.3vw);
                        }
                
                        .LanConActive{
                            border: 2px solid #ffa11a;
                            border-radius:10px;
                        }
                    }

                    .Separator{
                        display: inherit;
                        width: 100%;
                        height: 1px;
                        background-color: #95959561;
                        
                    }

                    .Profile{
                        width: 100%;
                        display: flex;
                        align-items:center;
                        gap: 1rem;

                        .DropdownName{
                            display: flex;
                            align-items: center;
                            gap: 0.7rem;

                            font-size: calc(0.8rem + 0.3vw);
                        }

                        .ImageContainer{
                            border: 1px solid #ff9000;
                            width: 42px;
                            height: 42px;
                            border-radius:10px;
                            .Image{
                                object-fit: cover;
                                width: 42px;
                                height: 42px;
                                border-radius:10px;
                            }
                        }

                        .triangle{
                            width: 0;
                            height: 0;
                            border-top: 8px solid #fe9f1a;
                            border-left: 7px solid transparent;
                            border-right: 7px solid transparent;
                        }

                        .rotate{
                            transform: rotate(180deg);
                        }
                            
                    }
                }

                .Separator{
                    margin: 0;
                    display: inherit;
                    width: 100%;
                    height: 1px;
                    background-color: #95959561;
                    
                }


            }

            .Sidebar-enter{
                width: 0;
                padding: 0;
            }

            .Sidebar-enter-active{
                width: 0;
                padding: 0;
            }

            .Sidebar-enter-done{
                width: 80%;
                transition: all 100ms;

            }


            .Sidebar-exit{
                width: 80%;
            }

            .Sidebar-exit-active{
                width: 0;
                opacity: 0;
                transition: all 300ms;
                
            }
        }

        .SidebarContainer-enter{
            background-color: rgba(0,0,0,0);
        }

        .SidebarContainer-enter-active{
            background-color: rgba(0,0,0,0);
        }

        .SidebarContainer-enter-done{
            background-color: rgba(0,0,0,0.4);

            transition: all 300ms;
        }

        .SidebarContainer-exit{
            background-color: rgba(0,0,0,0.4);
  
        }

        .SidebarContainer-exit-active{
            background-color: rgba(0,0,0,0);
         
            transition: all 300ms;
        }



    `;
}
